import { Activity } from "@finway-group/shared/lib/models"
// Redux imports
import { Action } from "redux"

export enum ActivityActionTypes {
    MARK_AS_VIEWED = "MARK_AS_VIEWED",
    FETCH_ACTIVITY = "FETCH_ACTIVITY",
    MARK_ALL_AS_VIEWED = "MARK_ALL_AS_VIEWED",
}

export interface MarkAsViewedAction extends Action<typeof ActivityActionTypes.MARK_AS_VIEWED> {
    type: typeof ActivityActionTypes.MARK_AS_VIEWED
    activity: Activity
}

export interface FetchActivityAction extends Action<typeof ActivityActionTypes.FETCH_ACTIVITY> {
    type: typeof ActivityActionTypes.FETCH_ACTIVITY
    activities: Activity[]
    totalUnseen: number
    append: boolean
    totalPages: number
    totalDocs: number
}

export interface markAllAsViewedAction extends Action<typeof ActivityActionTypes.MARK_ALL_AS_VIEWED> {
    type: typeof ActivityActionTypes.MARK_ALL_AS_VIEWED
    ids: string[]
    userId: string
}

export type ActivityActions = MarkAsViewedAction | FetchActivityAction | markAllAsViewedAction
